import { render } from "./IconImport.vue?vue&type=template&id=67fbee59&scoped=true"
const script = {}

import "./IconImport.vue?vue&type=style&index=0&id=67fbee59&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fbee59"]])

export default __exports__